module.exports = __webpack_public_path__ + "static/support_nofound-eea41f03144161ae71cdf5591ed2c9d3.png";